export const localStorage = {
  customizer: `${
    window.location.search === ""
      ? `bijvelds-${window.location.pathname.replaceAll("/", "")}`
      : window.location.search
          .replaceAll("?", "")
          .replaceAll("=", "-")
          .replaceAll("&", "__")
  }`,
  cartOfferte: "cart_offerte",
  optionsByModels: "optionsByModels"
};
